import MendiantsBox from "../../components/categories/MendiantsBox";

const Mendiants = () => {
  return (
    <div className="section-padding max-w-6xl mx-auto">

      <h1 className="text-4xl font-bold mb-12">
        Nos Mendiants
      </h1>

      {/* BOITES CLASSIQUES */}
      <MendiantsBox type="standard" />

      {/* PERSONNALISER */}
      <MendiantsBox type="personalise" />

    </div>
  );
};

export default Mendiants;